import { ROLE } from "constant/app";
import get from "lodash/get";
import PropTypes from "prop-types";

const ROLE_PROPS = {
  [ROLE.ADMIN]: { label: "Full access", labelColor: "red" },
  [ROLE.DISABLED]: { label: "Disabled", labelColor: "gray" },
  [ROLE.OPERATOR]: { label: "Operator", labelColor: "yellow" },
  [ROLE.READ_ONLY]: { label: "Read only", labelColor: "green" },
  [ROLE.SUB_ACCOUNT]: { label: "Sub account", labelColor: "blue" },
  [ROLE.ADMIN_OPERATOR]: { label: "Admin operator", labelColor: "orange" },
  [ROLE.UNKNOWN]: { label: "Unknown", labelColor: "gray" },
};

const RoleProp = PropTypes.shape({
  label: PropTypes.string.isRequired,
  labelColor: PropTypes.string,
});

function getRoleProp(user) {
  // Checks disabled value since the role values do not match the labels.
  if (user.disabled) {
    return ROLE_PROPS[ROLE.DISABLED];
  }

  return get(ROLE_PROPS, user.role, ROLE_PROPS[ROLE.UNKNOWN]);
}

export { getRoleProp, RoleProp };
